namespace Riepiloghi.Negozio {
    export interface RiepiloghiForm {
        Data: Serenity.DateEditor;
        Nominativo: Serenity.StringEditor;
        Venduto: Serenity.DecimalEditor;
        Vecchio: Serenity.DecimalEditor;
        Liquidi: Serenity.DecimalEditor;
        Pos: Serenity.DecimalEditor;
        Resta: Serenity.DecimalEditor;
        Boutique: Serenity.DecimalEditor;
        Albergo: Serenity.DecimalEditor;
        InseritoIl: Serenity.DateEditor;
    }

    export class RiepiloghiForm extends Serenity.PrefixedContext {
        static formKey = 'Negozio.Riepiloghi';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!RiepiloghiForm.init)  {
                RiepiloghiForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = s.DecimalEditor;

                Q.initFormType(RiepiloghiForm, [
                    'Data', w0,
                    'Nominativo', w1,
                    'Venduto', w2,
                    'Vecchio', w2,
                    'Liquidi', w2,
                    'Pos', w2,
                    'Resta', w2,
                    'Boutique', w2,
                    'Albergo', w2,
                    'InseritoIl', w0
                ]);
            }
        }
    }
}
